import { EventTypes, track } from '@mc/track-event'
import { PageType } from './types'

interface TrackVideoPlayProps {
  pageType: PageType
  slug?: string | null
  title?: string | null
  brightcoveVideoId?: string | null
  mediaUuid?: string
  sample?: { brightcoveVideoId?: string; mediaUuid?: string } | null
}

const getEventName = (pageType: PageType) =>
  pageType === 'series'
    ? EventTypes.COURSE_MARKETING_CLICK
    : EventTypes.EPISODE_PAGE_CLICK

export const trackTrailerVideoPlay = ({
  pageType,
  slug,
  title,
  brightcoveVideoId,
  mediaUuid,
}: TrackVideoPlayProps) => {
  track(getEventName(pageType), {
    class: slug,
    category: 'media-playback',
    location: 'about-this-original-series',
    action: 'Course Trailer',
    path: window.location.pathname,
    content_id: brightcoveVideoId ?? mediaUuid,
    content_title: title,
  })
}

export const trackSampleVideoPlay = ({
  pageType,
  slug,
  title,
  brightcoveVideoId,
  mediaUuid,
}: TrackVideoPlayProps) => {
  track(getEventName(pageType), {
    class: slug,
    category: 'media-playback',
    location: 'about-this-original-series',
    action: 'Course Preview',
    path: window.location.pathname,
    content_id: brightcoveVideoId ?? mediaUuid,
    content_title: title,
  })
}
